export default __webpack_public_path__ + "static/media/fr.58f2ed24.svg";